var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"sticky-header d-print-none"},[_c('HeaderSection',{staticClass:"d-print-none"}),(_vm.alert.msg)?_c('Alert',{attrs:{"alert":_vm.alert}}):_vm._e()],1),_c('main',{staticClass:"pb-5",attrs:{"id":"main"}},[_c('transition',{attrs:{"name":"fade"}},[_c('router-view')],1)],1),_c('FooterSection')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }